
export const useStages = () => {
  return [
    { label: "الصف اولي اعدادي", value: "11" },
    { label: "الصف الثاني اعدادي", value: "22" },
    { label: "الصف الثالث اعدادي", value: "33" },
    { label: "الصف الأول الثانوي", value: "1" },
    { label: "الصف الثاني الثانوي", value: "2" },
    { label: "الصف الثالث الثانوي", value: "3" },
  ];
};
